import script from "./subscribe.vue?vue&type=script&setup=true&lang=js"
export * from "./subscribe.vue?vue&type=script&setup=true&lang=js"

import "./subscribe.vue?vue&type=style&index=0&id=6c2a0fc1&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c2a0fc1"]])

export default __exports__